import { FaBuilding, FaUsers, FaServer, FaHeadset } from 'react-icons/fa6'
import useCounter from '../../../hooks/useCounter'

const statsConfig = [
  { end: 500, suffix: '+', label: 'ISP Terdaftar', icon: FaBuilding },
  { end: 50000, suffix: '+', label: 'Pelanggan Dikelola', icon: FaUsers },
  { end: 99, suffix: '.9%', label: 'Uptime Server', icon: FaServer },
  { end: 24, suffix: '/7', label: 'Customer Support', icon: FaHeadset },
]

export default function LpStatsSection() {
  const [c1, r1] = useCounter(500)
  const [c2, r2] = useCounter(50000)
  const [c3, r3] = useCounter(99)
  const [c4, r4] = useCounter(24)

  const counters = [c1, c2, c3, c4]
  const refs = [r1, r2, r3, r4]

  return (
    <section
      className="relative py-20 overflow-hidden"
      aria-labelledby="stats-heading"
    >
      <div
        className="absolute inset-0 bg-gradient-to-r from-ocean-900/30 via-navy-800 to-ocean-900/30"
        aria-hidden="true"
      />
      <div
        className="section-line absolute top-0 left-0 right-0"
        aria-hidden="true"
      />
      <div
        className="section-line absolute bottom-0 left-0 right-0"
        aria-hidden="true"
      />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <h2 id="stats-heading" className="sr-only">
          Statistik Radius Trend
        </h2>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {statsConfig.map((s, i) => {
            const Icon = s.icon
            return (
              <div
                key={i}
                ref={refs[i]}
                className="text-center reveal"
                style={{ transitionDelay: i * 0.1 + 's' }}
              >
                <div className="w-14 h-14 rounded-2xl bg-ocean-800/15 border border-ocean-700/20 flex items-center justify-center mx-auto mb-4">
                  <Icon className="text-ocean-500 text-xl" />
                </div>
                <div className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2">
                  {counters[i].toLocaleString('id-ID')}
                  {s.suffix}
                </div>
                <div className="text-slate-custom text-sm sm:text-base">
                  {s.label}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}